import { Chip, Divider, Grid } from '@mui/material'
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import UploadFileItem from 'components/Input/UploadFile';
import { useContext, useMemo, useState } from 'react'
import { ProviderAccPayment } from '../../AccountingPayment/AccountingPaymentForm';
import { Extension } from 'utilities/utilities';
import TableTotal from './TableTotal';
import moment from 'moment';

const TablePaymentSummary = () => {

    const {
        form,
        isView,
        onClearDepositSlip,
        arrDepositSlip,
        setArrDepositSlip,
        objValue,
    } = useContext(ProviderAccPayment);

    const [startDate, setStartDate] = useState(null);
    const TotalAmount = useMemo(() => {
        let nTotal = 0;
        if (objValue) {
            nTotal = objValue.nAmountTicketSold + objValue.nAmountRent + objValue.nAmountDonate
        }

        return nTotal;
    }, [objValue])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Divider textAlign="left"><Chip className='ticket-chip font-weight-500' label={"ข้อมูลนำฝาก"} /></Divider>
            </Grid>
            <Grid item xs={12} md={4}>
                <TableTotal sTitle={"ยอดรวมทั้งหมด"} nValue={TotalAmount} />
            </Grid>
            <Grid item xs={12}>
                <UploadFileItem
                    id="file-deposit"
                    name={"file-deposit"}
                    key={"file-deposit"}
                    label='ใบนำฝาก'
                    arrFile={arrDepositSlip}
                    setarrFile={setArrDepositSlip}
                    IsFolder={false}
                    IsMultiple={false}
                    Extension={Extension.FileTicket}
                    nLimitFile={30}
                    sLimitFile={"MB"}
                    onClearFile={onClearDepositSlip}
                    modeDisplay={"list"}
                    sFolderTemp={"Payment"}
                    sPositionText={"right"}
                    required={!isView}
                    disabled={isView}
                    IsHiddenUploadBox={isView}

                />
                {!isView && arrDepositSlip.length === 0 && <br />}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <DatePickerItem
                    name={"dDatePayment"}
                    id={"dDatePayment"}
                    label={`วันที่นำฝาก`}
                    IsDisablePortal={true}
                    fullWidth={true}
                    required={!isView}
                    disabled={isView}
                    maxDate={moment()}
                    onChange={(e) => {
                        form.setValue("dDateDeposit", e)
                        form.clearErrors("dDateDeposit")
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <DatePickerItem
                    name={"dDateDeposit"}
                    id={"dDateDeposit"}
                    label={`เงินนำฝากประจำเดือน`}
                    IsDisablePortal={true}
                    fullWidth={true}
                    required={!isView}
                    disabled={isView}
                    IsMonthYearPicker
                    format='MMM/YYYY'
                    maxDate={moment()}

                />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <DatePickerItem
                            id={`nStartDate`}
                            name={`nStartDate`}
                            label={`วันที่นำฝากเริ่มต้น`}
                            IsDisablePortal={true}
                            fullWidth
                            required={!isView}
                            disabled={isView}
                            onChange={(e) => {
                                setStartDate(e);
                                if (e) {
                                    form.setValue("nEndDate", null);
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DatePickerItem
                            id={`nEndDate`}
                            name={`nEndDate`}
                            label={`วันที่นำฝากสิ้นสุด`}
                            IsDisablePortal={true}
                            minDate={startDate}
                            fullWidth
                            required={!isView}
                            disabled={isView}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

    )
}

export default TablePaymentSummary